import {Layout, Menu} from "antd";
import {Link} from "react-router-dom";

const { Header } = Layout;

function MainMenu(props){
    const active = props.active;
    return(
        <Header>
            <Menu theme="dark" mode="horizontal" defaultSelectedKeys={active}>
                <Menu.Item key="1">
                    <Link to="/home">
                        Home
                    </Link>
                </Menu.Item>
                <Menu.Item key="2">
                    <Link to="/cadastrar-prova">
                        Cadastrar Prova
                    </Link>
                </Menu.Item>
            </Menu>
        </Header>
    )
}

export default MainMenu;